module.exports = __webpack_public_path__ + "static/media/runnin-man.a0ec22e5.mp4";